<template>
    <div>
        <v-row justify="center">
            <v-dialog
                v-model="dialog"
                persistent
                max-width="330px">
                <v-card>
                    <v-card-title>
                        <span
                            class="headline">
                            {{ $vuetify.lang.t('$vuetify.errorModal.somethingWrong')}}
                        </span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                {{ this.$store.state.errorModalMsg }}
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            @click="closeModal()">
                            {{ $vuetify.lang.t('$vuetify.errorModal.close')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
export default {
    name: 'ErrorModal',

    data () {
        return {
            dialog: this.$store.state.errorModalShow
        }
    },

    methods: {
        closeModal () {
            this.dialog = false
            this.$store.dispatch('setErrorModalShow', false)
            this.$store.dispatch('setErrorModalMsg', '')
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
